type ChatMessageCaptionProps = {
  caption?: string;
  children: React.ReactNode;
};

const ChatMessageCaption: React.FC<ChatMessageCaptionProps> = ({
  children,
  caption,
}) => (
  <figure style={{ margin: 0, display: 'table' }}>
    {children}
    {caption && (
      <figcaption
        className="ChatMessageCaption"
        style={{
          display: 'table-caption',
          captionSide: 'bottom',
          paddingTop: 5,
        }}
      >
        {caption}
      </figcaption>
    )}
  </figure>
);

export default ChatMessageCaption;
